import React, { useEffect } from "react";
import '../eyeTest.css';
import { useRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { eyeTestState } from '../../../../utils/recoil/eyeTest';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { Button } from '../../../UI/Elements';
import { Component } from '../../../Contentful/component';

export const EyeTestResult = ({ triggerEvent, scrollUp, resultStep, resultNoCorrection }) => {
  const { button, form, label, content } =
    formatContentfulComponentProps(resultStep);
  const noCorrection = formatContentfulComponentProps(resultNoCorrection);
  const [eyeTest, setEyeTest] = useRecoilState(eyeTestState);
  const { currentStep, fullSuccess } = eyeTest;

  const handleRestart = () => {
    setEyeTest({
      ...eyeTest,
      formValue: '',
      currentStep: 0,
      isCompleted: false,
      isInit: true,
    });
    scrollUp();
  };
  const contentProps = fullSuccess ? noCorrection.content : content;

  useEffect(() => {
    triggerEvent();
  }, [])

  return (
    <div className='w-full'>
      <section className='w-full left-0 h-72 lg:h-96 flex flex-col items-center justify-center'>
        <div className='w-screen h-72 lg:h-96 eye-test-bg absolute left-0 -z-1'></div>
        <div className='mb-12 w-full flex justify-center'>
          <div className='pr-2'>
            <Label
              size='5xl'
              weight='bold'
              text={label?.text}
            />
          </div>
          <Label
            size='5xl'
            weight='bold'
            text={
              fullSuccess
                ? noCorrection.label?.text
                : `+${form.inputs[currentStep].metaData.diopter}`
            }
          />
        </div>
        <Button
          type='contained'
          color={{ classname: 'reading' }}
          label={{ text: button.label?.text }}
          onClick={handleRestart}
        />
      </section>
      <section className='my-16'>
        {contentProps && <Component {...contentProps} />}
      </section>
    </div>
  );
};
